export enum ApiUserManager {
  //Create New User
  CREATE_USER = 'user',
  //Create New Admin
  CREATE_USER_ADMIN = 'user/admin',
  //Login findById
  USER_LOGIN = 'admin/user/login',
 // USER_LOGOUT = 'user/logout',
  USER_REGISTER = 'admin/user',

  SOCIAL_MEDIA_LOGIN = '/social-media',

  USER_VALIDATE = 'admin/user/validate',
  USER_BASIC_INFO = 'admin/user/basic',
   UPDATE_USER_BASIC_INFO = 'admin/user/info',
  UPDATE_USER_PASSWORD = 'admin/user/password',
  USER_PLANS =  'admin/account/setting/business-plan',
  RESEND_VALIDATION_EMAIL= 'admin/user/resend/validation-email',
  SEND_RECOVER = 'admin/user/recover/password/send',
  NEW_PASS = 'admin/user/recover/password/update',
  NOTIFICATION_BANNER = 'admin/account/notification/banner',
  USER_WELCOME_TOUR = 'admin/user/welcome/tour'
}
